import { graphql } from '../../__generated__';

export const DELETE_FROM_EXTERNAL_PORTFOLIO = graphql(`
  mutation DeleteFromExternalPortfolio($externalPortfolioId: Int!) {
    externalPortfolioRemoveFromExternalPortfolio(externalPortfolioId: $externalPortfolioId)
  }
`);
